import { useTranslation } from "next-i18next";
import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import { Employee } from "@/lib/types/Employee";
import PageHead from "@/src/shared/PageHead";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import Header from "@/src/shared/Header/Header";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import BackToTop from "@/src/shared/BackToTop";
import TeamPage from "@/src/features/team/TeamPage";
import TeamPageContext, { ITeamPageContext } from "@/src/features/team/TeamPageContext";
import API from "@/lib/api";

export default function Team({ page }: { page: ITeamPageContext }) {
  const { t } = useTranslation();

  return (
    <TeamPageContext.Provider value={page}>
      <PageHead title={t("ourTeam")} />
      <Header />
      <MobileMenu />
      <TeamPage />
      <BackToTop />
      <Separator />
      <Footer />
    </TeamPageContext.Provider>
  );
}

export const getServerSideProps = sharedServerSideProps(async () => {
  return {
    page: {
      employees: await API.Client.get<Employee[]>("/api/employee/list", {
        params: { Skip: 0, Take: 200, "Filters[IsActive]": true }
      })
    }
  };
});
